import React, { useState } from "react";
import dayjs from "dayjs";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const EndDateDialog = ({
  deletedRowIdRef,
  endDateOpen,
  setEndDateOpen,
  saveEndDate,
}) => {
  const [endDate, setEndDate] = useState(dayjs());
  const [endDateError, setEndDateError] = useState(false);

  // derive instead of storing
  const endDateErrorMessage = endDateError
    ? "End date must be the current or a future day."
    : "";

  const handleSaveEndDate = (date) => {
    saveEndDate(date);
    handleClose();
  };

  const handleClose = () => {
    // reset local state on close (no effects needed)
    setEndDate(dayjs());
    setEndDateError(false);
    deletedRowIdRef.current = null;
    setEndDateOpen(false);
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={endDateOpen} onClose={handleClose}>
      <DialogTitle fontWeight="fontWeightBold">End Date</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Select the end date for this rule.
        </DialogContentText>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            disablePast
            onError={(error) => setEndDateError(Boolean(error))}
            slots={{ openPickerIcon: CalendarMonth }}
            slotProps={{
              textField: {
                fullWidth: true,
                helperText: endDateErrorMessage,
              },
            }}
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          disabled={endDateError}
          onClick={() => handleSaveEndDate(endDate)}
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EndDateDialog;
